export class SearchFacetRangeFilter {
  public token: string;
  public fromValue: string;
  public toValue: string;
  public label: string;
  public query: string;
  public field: string;
  public value: string;
  public excludedFacet: boolean;

  constructor() {
    this.token = '';
    this.fromValue = '';
    this.toValue = '';
    this.label = '';
    this.query = '';
    this.field = '';
    this.value = '';
    this.excludedFacet = false;
  }
}
